var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.8333,
    cy: 23.875,
    r: 18.0833,
    transform: "rotate(-180 25.8333 23.875)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 23.875C46.5 11.0535 36.0715 0.625 23.25 0.624999C10.4286 0.624998 1.09882e-05 11.0535 1.04278e-05 23.875C9.86736e-06 36.6964 10.4285 47.125 23.25 47.125C36.0715 47.125 46.5 36.6964 46.5 23.875ZM25.5679 34.6984L15.4592 24.5897C15.2618 24.3923 15.163 24.1356 15.163 23.875C15.163 23.6144 15.2618 23.3577 15.4592 23.1603L25.5679 13.0516C25.9628 12.6567 26.6025 12.6567 26.9973 13.0516C27.3922 13.4465 27.3922 14.0861 26.9973 14.481L17.6034 23.875L26.9973 33.269C27.3922 33.6638 27.3922 34.3035 26.9973 34.6984C26.6025 35.0933 25.9628 35.0933 25.5679 34.6984Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftButton);
export default __webpack_public_path__ + "static/media/left-button.979198d0eb744d746cfaf990cc74d9d8.svg";
export { ForwardRef as ReactComponent };